import { useTranslation } from 'react-i18next';
import { ResponseError } from '@clickersphere/core/entities/ResponseError';
import { errorsCode } from '@clickersphere/core/utils/consts/errorsCode';
import useToast from './useToast';

export function useError() {
  const { toast } = useToast();
  const { t } = useTranslation();

  function handleError(error: ResponseError) {
    toast(t(errorsCode[error.code]), 'error');
  }

  return { handleError };
}
